import { Box } from '@deity/falcon-ui';
import { Select } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IHostProps {
  protocol?: string;
  parent?: string;
  isEditable: boolean;
  onChange: (path: string[], val: string) => void;
}

export const Protocol: FC<IHostProps> = ({ isEditable, protocol, parent, onChange }) => {
  const label = !protocol && parent ? `${parent.toUpperCase()} (inherited)` : 'Protocol';
  const isError = !protocol && !parent;

  return (
    <Box style={{ width: '50%' }}>
      <Select
        label={label}
        sx={{ marginY: 1 }}
        onChange={(val: any) => onChange(['protocol'], val?.value)}
        options={['http', 'https']?.map(p => ({
          value: p,
          label: p.toUpperCase()
        }))}
        value={protocol ? { label: protocol?.toUpperCase(), value: protocol } : undefined}
        disabled={!isEditable}
        autoComplete={false}
        error={isError}
        disableClearable={false}
      />
    </Box>
  );
};
